import React from 'react';

const SightListItem = ({ title, isActive }) => (
	<div>
		<h4 style={{ color: isActive ? 'red' : 'white'}}>{title}</h4>
	</div>
);

export default SightListItem;